export default function() {
    return {
        photos: [],
        newPhotos: [],
        percent: 1,
        uploading: false,
        processedPhotos: 0,
        currentUploadingPhoto: 0,
        sortingChanged: false
    }
}
